import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { messages } from './messages';
import { PurchaseOrderProvider } from './purchase-order-context';
import { ReceivedProductsProvider } from './purchase-order-page/receive/purchase-order-receiving-context';
import { ReceivePurchaseOrderDrawer } from './receive-purchase-order-drawer/receive-purchase-order-drawer';
import { useWarehouseLocations } from './receive-purchase-order-drawer/use-warehouse-locations';
import { useModal } from '../../../hooks/use-modal';

/**
 * Button that opens a drawer to receive a purchase order
 * @param {object} props - Component props
 * @param {object} props.purchaseOrder - The purchase order data
 * @param {object} [props.buttonMessage] - Message for button text
 * @param {string} [props.className] - CSS class name
 * @param {string} props.theme - Button theme
 * @param {boolean} props.disabled - Whether the button is disabled
 * @param {() => void} [props.refreshCallback] - optional refresh function to call after successful receive
 * @returns {JSX.Element} The button component
 */
export const ReceivePurchaseOrderButton = ({
  purchaseOrder,
  buttonMessage = messages.receivePurchaseOrderButton,
  className = '',
  theme,
  disabled,
  refreshCallback,
}) => {
  const { isOpen, open, close } = useModal();
  const warehouseId = purchaseOrder?.warehouseId;
  const warehouseLocations = useWarehouseLocations(warehouseId);

  return (
    <>
      <Button className={className} data-testid='receive-purchase-order-button' disabled={disabled} onClick={open} theme={theme}>
        <FormattedMessage {...buttonMessage} />
      </Button>

      {isOpen ? (
        <PurchaseOrderProvider
          onClose={close}
          purchaseOrder={purchaseOrder}
          purchaseOrderId={purchaseOrder?.purchaseOrderId}
          title={messages.receivePurchaseOrderTitle.defaultMessage}
        >
          <ReceivedProductsProvider purchaseOrderId={purchaseOrder?.purchaseOrderId} warehouseLocations={warehouseLocations}>
            <ReceivePurchaseOrderDrawer onClose={close} refreshCallback={refreshCallback} />
          </ReceivedProductsProvider>
        </PurchaseOrderProvider>
      ) : null}
    </>
  );
};
